import { LoadableAfterPaint } from '@confluence/loadable';

export const HighlightsBylineButton = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HighlightsBylineButton" */
				'../src/HighlightsBylineButton.tsx'
			)
		).HighlightsBylineButton,
});
